import { FILTER_GRAPH } from '@/engine/filter-graph.js';
import { removeAllFilters } from '@/engine/filter-patch.js';

/**
 * @typedef {import('@/types').FilterOptions} FilterOptions
 * @typedef {import('@/types').FilterSelected} FilterSelected
 * @typedef {import('@/types').StepRuntime} StepRuntime
 */

/**
 * @typedef {Object} FilterIntent
 * @property {'INIT'|'COMMIT_FILTER'|'REMOVE_FILTER'|'REMOVE_ALL_FILTERS'|'PAGINATE'|'CATEGORY_NAV'} type
 * @property {string} [source]
 * @property {StepRuntime} [runtime]
 */

/**
 * @param {FilterIntent} intent
 * @param {{ lockCollegeFilter?: boolean, options?: FilterOptions, selected?: FilterSelected }} [context]
 * @returns {{ plan: import('@/engine/filter-graph.js').FilterPlan|null, source: string|null }}
 */
export function resolvePlan(intent, context = {}) {
	switch (intent.type) {
		case 'INIT':
			return { plan: FILTER_GRAPH.init, source: null };
		case 'COMMIT_FILTER':
		case 'REMOVE_FILTER':
			if (!intent.source || !FILTER_GRAPH[intent.source]) {
				throw new Error(`No filter plan for source: ${intent.source}`);
			}
			return { plan: FILTER_GRAPH[intent.source], source: intent.source };
		case 'REMOVE_ALL_FILTERS': {
			if (!context.options || !context.selected) {
				throw new Error('REMOVE_ALL_FILTERS requires options and selected on engine context');
			}

			let { cascadeSource } = removeAllFilters(context.options, context.selected, {
				lockCollege: context.lockCollegeFilter ?? false,
			});

			if (!cascadeSource || !FILTER_GRAPH[cascadeSource]) {
				return { plan: null, source: null };
			}

			return { plan: FILTER_GRAPH[cascadeSource], source: cascadeSource };
		}
		case 'PAGINATE':
			return { plan: FILTER_GRAPH.paginate, source: null };
		case 'CATEGORY_NAV':
			return { plan: FILTER_GRAPH.categoryNav, source: null };
		default:
			throw new Error(`Unknown intent type: ${intent.type}`);
	}
}
